import type { AgentNodeData } from '@saaga/shared/interfaces/agency-node.interface'
import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import { AgencyFlowDeleteDialog } from './agency-flow-delete-dialog.atom'
import { AgencyFlowEdgePopover } from './agency-flow-edge-popover.atom'
import { AgentNodeResizableDrawer } from './agent-node-resizable-drawer.organism'
import type { useAgencyFlowCanvas } from './use-agency-flow-canvas.hook'

interface AgencyFlowDialogsProps {
  canvas: ReturnType<typeof useAgencyFlowCanvas>
  nodeData: AgentNodeData | null
  nodeId: string | null
  modelList: LlmModel[]
  isLoadingModels: boolean
  toolList: AgentTool[]
  isLoadingTools: boolean
}

export const AgencyFlowDialogs = ({
  canvas,
  nodeData,
  nodeId,
  modelList,
  isLoadingModels,
  toolList,
  isLoadingTools,
}: AgencyFlowDialogsProps): ReactNode => (
  <>
    <AgentNodeResizableDrawer
      isOpen={canvas.isDrawerOpen}
      onOpenChange={canvas.handlers.handleDrawerOpenChange}
      nodeData={nodeData}
      nodeId={nodeId}
      onSave={canvas.handlers.handleSaveNode}
      modelList={modelList}
      isLoadingModels={isLoadingModels}
      toolList={toolList}
      isLoadingTools={isLoadingTools}
    />
    <AgencyFlowDeleteDialog
      state={canvas.deleteDialogState}
      onClose={canvas.handlers.closeDeleteDialog}
      onConfirm={canvas.handlers.handleDeleteConfirm}
    />
    <AgencyFlowEdgePopover
      state={canvas.edgePopoverState}
      onOpenChange={canvas.handlers.handleEdgePopoverOpenChange}
      onSave={canvas.handlers.handleEdgeLabelSave}
    />
  </>
)

AgencyFlowDialogs.displayName = 'AgencyFlowDialogs'
